/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "quote-350904ef--sprite",
  "use": "quote-350904ef--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"quote-350904ef--sprite\"><defs><clipPath id=\"quote-350904ef--sprite_a\"><ellipse cx=\"17.921\" cy=\"18\" rx=\"17.921\" ry=\"18\" fill=\"#dffae6\" stroke=\"#d8d8d8\" stroke-width=\"1\" /></clipPath></defs><path d=\"M17.921,0A18,18,0,1,1,0,18,17.961,17.961,0,0,1,17.921,0Z\" fill=\"#dffae6\" opacity=\"0\" /><g transform=\"translate(12 13)\"><path d=\"M1229.7,1258.226v-2.863a.919.919,0,0,1,.919-.919h2.5a.919.919,0,0,1,.919.919v2.8a9.8,9.8,0,0,1-.725,4.365,5.956,5.956,0,0,1-2.147,2.294.927.927,0,0,1-1.276-.291l-.02-.033a.932.932,0,0,1,.28-1.256,3.628,3.628,0,0,0,.99-1.053,1.311,1.311,0,0,0,.069-.129,6.52,6.52,0,0,0,.554-1.859.924.924,0,0,0-.913-1.054h-.231A.919.919,0,0,1,1229.7,1258.226Zm-6.967,0v-2.863a.919.919,0,0,1,.919-.919h2.5a.919.919,0,0,1,.919.919v2.8a9.8,9.8,0,0,1-.725,4.365,5.957,5.957,0,0,1-2.152,2.3.927.927,0,0,1-1.273-.287l-.023-.036a.934.934,0,0,1,.279-1.263,3.553,3.553,0,0,0,.983-1.053,1.382,1.382,0,0,0,.067-.125,6.527,6.527,0,0,0,.555-1.861.924.924,0,0,0-.913-1.054h-.218A.919.919,0,0,1,1222.731,1258.226Z\" transform=\"translate(-1222.731 -1254.444)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
